import CandidateApplicationTable from './../components/table/CandidateApplication'
import PostedJobsTable from './../components/table/PostedJobs'
import ContactFormTable from './../components/table/ContactForm'
import TestimonalsTable from './../components/table/Testimonals'
import { Navigate } from 'react-router-dom';
import axios from 'axios'
import { useState, useEffect } from 'react'


import './style.css'

function Dashboard(){
  const [isAuth, setIsAuth] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    const isAuthenticated = () => {
      axios.get('https://job-portal-back123.herokuapp.com/auth/admin/verify', {
        credentials: "include",
        withCredentials: true,
        headers: {
          Authorization: localStorage.getItem("token")
        }
      }).then(res => {
        setIsAuth(res.data.success)
        setIsLoading(false)
      }).catch(err => {
        console.log(err)
        window.location = "/admin/signin"
      })
    }
    isAuthenticated()
  }, [])
  return(
    <>
      {isLoading && <div>Loading...</div>}
      {(!isLoading && !isAuth) && <Navigate to="/admin/signin" />}
      {(!isLoading && isAuth) && (
        <main className="admin__component">
          <section>
            <h2>Slider Images</h2>

          </section>
          <div className="dashboard__wrap">

            <section>
              <CandidateApplicationTable />
            </section>

            <section>
              <PostedJobsTable />
            </section>

            <section>
              <ContactFormTable />
            </section>

            <section>
              <TestimonalsTable />
            </section>

          </div>
        </main>
      )}
    </>
  )
}

export default Dashboard
